import { render, staticRenderFns } from "./IconEmojiSadSolid.vue?vue&type=template&id=9a5293ba"
import script from "./IconEmojiSadSolid.vue?vue&type=script&lang=js"
export * from "./IconEmojiSadSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports